<template>
  <div class="backdrop">
    <div class="backdrop-top">
      <div class="title-box">
        <img src="../../../assets/images/return.png"><span>维修耗材出库单</span>
      </div>
      <div class="common head-wrapper">
        <div class="layout row">
          <label>维修耗材出库单：</label>
          <span class="flex-1">200928-001</span>
          <span class="green">未入账</span>
        </div>
        <div class="layout row">
          <label>维修单：</label>
          <span class="flex-1">24523542345（受理中）</span>
        </div>
        <div class="layout row">
          <label>仓库：</label>
          <span class="flex-1">小区名-仓库名</span>
        </div>
        <div class="head-img">
          <img src="../../../assets/images/mine-information-bj.png">
          <img src="../../../assets/images/mine-information-bj.png">
          <img src="../../../assets/images/mine-information-bj.png">
          <img src="../../../assets/images/mine-information-bj.png">
          <img src="../../../assets/images/mine-information-bj.png">
        </div>
        <div>备注：备注备注备注</div>
        <div class="head-goods">
          商品种类：<span class="blue">4种</span>
          总件数：<span class="blue">120件</span>
        </div>
      </div>
      <div class="common goods-wrapper">
        <div class="table-head layout">
          <label></label>
          <label></label>
          <label class="flex-1">品名/条码</label>
          <label>数量</label>
        </div>
        <div class="layout">
          <label>1</label>
          <label><img src="../../../assets/images/mine-information-bj.png"></label>
          <label class="flex-1">
            <div class="name">晨光笔</div>
            <div class="name">6945354315312</div>
          </label>
          <label>20</label>
        </div>
        <div class="layout">
          <label>2</label>
          <label><img src="../../../assets/images/mine-information-bj.png"></label>
          <label class="flex-1">
            <div class="name">A4纸</div>
            <div class="name">6945354315312</div>
          </label>
          <label>20</label>
        </div>
        <div class="layout">
          <label>3</label>
          <label><img src="../../../assets/images/mine-information-bj.png"></label>
          <label class="flex-1">
            <div class="name">灭火器</div>
            <div class="name">6945354315312</div>
          </label>
          <label>20</label>
        </div>
      </div>
      <div class="common record-wrapper">
        <div class="record-title">操作记录</div>
        <div class="record-row layout">
          <span>创建 2020-11-20 09:38:49</span>
          <span class="flex-1">杨正亚</span>
        </div>
        <div class="record-row layout">
          <span>入账 2020-11-20 09:38:49</span>
          <span class="flex-1">杨正亚</span>
        </div>
        <div class="record-row layout">
          <span>作废 2020-11-20 09:38:49</span>
          <span class="flex-1">杨正亚</span>
        </div>
      </div>
    </div>
    <div class="backdrop-bottom">
      <button class="entry-btn">入账</button>
      <button class="edit-btn">编辑</button>
      <button class="del-btn">删除</button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'WarehouseOutDetail',
  metaInfo: {
    title: '物资管理'
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
<style scoped>
.common {
  padding: 10px 15px;
}
.backdrop {
  overflow: hidden;
}
.backdrop-top {
  height: calc(100% - 50px);
  overflow-y: auto;
}
.head-wrapper {
  font-size: 15px
}
.head-wrapper .row {
  line-height: 25px;
}
.head-wrapper .row label {
  width: 125px;
}
.head-wrapper .head-img img {
  width: 60px;
  height: 60px;
  margin: 10px 5px 10px 0 ;
}
.head-wrapper .head-goods {
  margin-top: 10px;
}
.head-wrapper .head-goods span {
  padding-right: 15px;
}
.goods-wrapper {
  font-size: 15px
}
.goods-wrapper .table-head {
  border-bottom: 1px solid #e9e9e9;
}
.goods-wrapper .table-head label {
  height: 35px;
  line-height: 35px;
}
.goods-wrapper img {
  width: 35px;
  height: 35px;
  vertical-align: middle;
  padding-right: 10px;
}
.goods-wrapper label {
  min-width: 25px;
  height: 50px;
  line-height: 50px;
}
.goods-wrapper label .name {
  line-height: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-all;
}
.goods-wrapper label .name:first-child {
  margin-top: 8px;
}
.record-wrapper {
  font-size: 15px;
}
.record-wrapper .record-title {
  font-weight: 700;
}
.record-wrapper .record-row {
  margin-top: 8px;
}
.record-wrapper .record-row .flex-1 {
  text-align: right;
}
.backdrop-bottom {
  height: 50px;
  background-color: #ffffff;
  padding: 10px 15px;
}
.backdrop-bottom button {
  height: 30px;
  line-height: 29px;
  background-color: #ffffff;
  border-radius: 15px;
  border: 1px solid #7c7b80;
  color: #7c7b80;
  font-size: 14px;
  padding: 0 14px;
  float: right;
  margin-left: 15px;
}
.backdrop-bottom .entry-btn {
  background-color: #ff7c12;
  border: 1px solid #ff7c12;
  color: #ffffff;
}
.layout {
  display: flex;
}
.layout .flex-1 {
  flex: 1;
}
.layout .flex-2 {
  flex: 2;
}
.green {
  color: #35c53b;
}
.blue {
  color: #25ade0;
}
</style>



// WEBPACK FOOTER //
// src/components/Material/WarehouseOut/WarehouseOutDetail.vue